/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminListSeasonPassesResponse,
  ApiError,
  CreateSeasonPassBody,
  GetSeasonPassesResponse,
  SeasonPassResponse,
  UpdateSeasonPassBody,
  UserSeasonProgressResponse,
} from '../models/index';
import {
    AdminListSeasonPassesResponseFromJSON,
    AdminListSeasonPassesResponseToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreateSeasonPassBodyFromJSON,
    CreateSeasonPassBodyToJSON,
    GetSeasonPassesResponseFromJSON,
    GetSeasonPassesResponseToJSON,
    SeasonPassResponseFromJSON,
    SeasonPassResponseToJSON,
    UpdateSeasonPassBodyFromJSON,
    UpdateSeasonPassBodyToJSON,
    UserSeasonProgressResponseFromJSON,
    UserSeasonProgressResponseToJSON,
} from '../models/index';

export interface CreateAdminSeasonPassesRequest {
    createSeasonPassBody: CreateSeasonPassBody;
}

export interface CreateSeasonPassesIdClaimTierTierNumberRequest {
    id: string;
    tierNumber: number;
}

export interface DeleteAdminSeasonPassesIdRequest {
    id: string;
}

export interface GetAdminSeasonPassesRequest {
    limit?: number;
    offset?: number;
    status?: string;
}

export interface GetAdminSeasonPassesIdRequest {
    id: string;
}

export interface GetSeasonPassesIdMyProgressRequest {
    id: string;
}

export interface UpdateAdminSeasonPassesIdRequest {
    id: string;
    updateSeasonPassBody: UpdateSeasonPassBody;
}

/**
 * SeasonPassesApi - interface
 * 
 * @export
 * @interface SeasonPassesApiInterface
 */
export interface SeasonPassesApiInterface {
    /**
     * Create a new season pass
     * @param {CreateSeasonPassBody} createSeasonPassBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonPassesApiInterface
     */
    createAdminSeasonPassesRaw(requestParameters: CreateAdminSeasonPassesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SeasonPassResponse>>;

    /**
     * Create a new season pass
     */
    createAdminSeasonPasses(requestParameters: CreateAdminSeasonPassesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SeasonPassResponse>;

    /**
     * Claim rewards for an unlocked season pass tier
     * @param {string} id 
     * @param {number} tierNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonPassesApiInterface
     */
    createSeasonPassesIdClaimTierTierNumberRaw(requestParameters: CreateSeasonPassesIdClaimTierTierNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSeasonProgressResponse>>;

    /**
     * Claim rewards for an unlocked season pass tier
     */
    createSeasonPassesIdClaimTierTierNumber(requestParameters: CreateSeasonPassesIdClaimTierTierNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSeasonProgressResponse>;

    /**
     * Delete a season pass. Only allowed when status is DRAFT.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonPassesApiInterface
     */
    deleteAdminSeasonPassesIdRaw(requestParameters: DeleteAdminSeasonPassesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a season pass. Only allowed when status is DRAFT.
     */
    deleteAdminSeasonPassesId(requestParameters: DeleteAdminSeasonPassesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * List season passes (paginated). Optionally filter by status.
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonPassesApiInterface
     */
    getAdminSeasonPassesRaw(requestParameters: GetAdminSeasonPassesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminListSeasonPassesResponse>>;

    /**
     * List season passes (paginated). Optionally filter by status.
     */
    getAdminSeasonPasses(requestParameters: GetAdminSeasonPassesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminListSeasonPassesResponse>;

    /**
     * Get a single season pass by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonPassesApiInterface
     */
    getAdminSeasonPassesIdRaw(requestParameters: GetAdminSeasonPassesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SeasonPassResponse>>;

    /**
     * Get a single season pass by ID
     */
    getAdminSeasonPassesId(requestParameters: GetAdminSeasonPassesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SeasonPassResponse>;

    /**
     * List all currently active season passes. Authenticated users only receive HUB-scoped passes for hubs they follow.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonPassesApiInterface
     */
    getSeasonPassesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSeasonPassesResponse>>;

    /**
     * List all currently active season passes. Authenticated users only receive HUB-scoped passes for hubs they follow.
     */
    getSeasonPasses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSeasonPassesResponse>;

    /**
     * Get the authenticated user\'s progression in a season pass
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonPassesApiInterface
     */
    getSeasonPassesIdMyProgressRaw(requestParameters: GetSeasonPassesIdMyProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSeasonProgressResponse>>;

    /**
     * Get the authenticated user\'s progression in a season pass
     */
    getSeasonPassesIdMyProgress(requestParameters: GetSeasonPassesIdMyProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSeasonProgressResponse>;

    /**
     * Update a season pass
     * @param {string} id 
     * @param {UpdateSeasonPassBody} updateSeasonPassBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonPassesApiInterface
     */
    updateAdminSeasonPassesIdRaw(requestParameters: UpdateAdminSeasonPassesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SeasonPassResponse>>;

    /**
     * Update a season pass
     */
    updateAdminSeasonPassesId(requestParameters: UpdateAdminSeasonPassesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SeasonPassResponse>;

}

/**
 * 
 */
export class SeasonPassesApi extends runtime.BaseAPI implements SeasonPassesApiInterface {

    /**
     * Create a new season pass
     */
    async createAdminSeasonPassesRaw(requestParameters: CreateAdminSeasonPassesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SeasonPassResponse>> {
        if (requestParameters['createSeasonPassBody'] == null) {
            throw new runtime.RequiredError(
                'createSeasonPassBody',
                'Required parameter "createSeasonPassBody" was null or undefined when calling createAdminSeasonPasses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/season-passes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSeasonPassBodyToJSON(requestParameters['createSeasonPassBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SeasonPassResponseFromJSON(jsonValue));
    }

    /**
     * Create a new season pass
     */
    async createAdminSeasonPasses(requestParameters: CreateAdminSeasonPassesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SeasonPassResponse> {
        const response = await this.createAdminSeasonPassesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Claim rewards for an unlocked season pass tier
     */
    async createSeasonPassesIdClaimTierTierNumberRaw(requestParameters: CreateSeasonPassesIdClaimTierTierNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSeasonProgressResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createSeasonPassesIdClaimTierTierNumber().'
            );
        }

        if (requestParameters['tierNumber'] == null) {
            throw new runtime.RequiredError(
                'tierNumber',
                'Required parameter "tierNumber" was null or undefined when calling createSeasonPassesIdClaimTierTierNumber().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/season-passes/{id}/claim-tier/{tierNumber}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"tierNumber"}}`, encodeURIComponent(String(requestParameters['tierNumber'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSeasonProgressResponseFromJSON(jsonValue));
    }

    /**
     * Claim rewards for an unlocked season pass tier
     */
    async createSeasonPassesIdClaimTierTierNumber(requestParameters: CreateSeasonPassesIdClaimTierTierNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSeasonProgressResponse> {
        const response = await this.createSeasonPassesIdClaimTierTierNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a season pass. Only allowed when status is DRAFT.
     */
    async deleteAdminSeasonPassesIdRaw(requestParameters: DeleteAdminSeasonPassesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAdminSeasonPassesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/season-passes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a season pass. Only allowed when status is DRAFT.
     */
    async deleteAdminSeasonPassesId(requestParameters: DeleteAdminSeasonPassesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdminSeasonPassesIdRaw(requestParameters, initOverrides);
    }

    /**
     * List season passes (paginated). Optionally filter by status.
     */
    async getAdminSeasonPassesRaw(requestParameters: GetAdminSeasonPassesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminListSeasonPassesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/season-passes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminListSeasonPassesResponseFromJSON(jsonValue));
    }

    /**
     * List season passes (paginated). Optionally filter by status.
     */
    async getAdminSeasonPasses(requestParameters: GetAdminSeasonPassesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminListSeasonPassesResponse> {
        const response = await this.getAdminSeasonPassesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a single season pass by ID
     */
    async getAdminSeasonPassesIdRaw(requestParameters: GetAdminSeasonPassesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SeasonPassResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAdminSeasonPassesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/season-passes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SeasonPassResponseFromJSON(jsonValue));
    }

    /**
     * Get a single season pass by ID
     */
    async getAdminSeasonPassesId(requestParameters: GetAdminSeasonPassesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SeasonPassResponse> {
        const response = await this.getAdminSeasonPassesIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all currently active season passes. Authenticated users only receive HUB-scoped passes for hubs they follow.
     */
    async getSeasonPassesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSeasonPassesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/season-passes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSeasonPassesResponseFromJSON(jsonValue));
    }

    /**
     * List all currently active season passes. Authenticated users only receive HUB-scoped passes for hubs they follow.
     */
    async getSeasonPasses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSeasonPassesResponse> {
        const response = await this.getSeasonPassesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the authenticated user\'s progression in a season pass
     */
    async getSeasonPassesIdMyProgressRaw(requestParameters: GetSeasonPassesIdMyProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSeasonProgressResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSeasonPassesIdMyProgress().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/season-passes/{id}/my-progress`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSeasonProgressResponseFromJSON(jsonValue));
    }

    /**
     * Get the authenticated user\'s progression in a season pass
     */
    async getSeasonPassesIdMyProgress(requestParameters: GetSeasonPassesIdMyProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSeasonProgressResponse> {
        const response = await this.getSeasonPassesIdMyProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a season pass
     */
    async updateAdminSeasonPassesIdRaw(requestParameters: UpdateAdminSeasonPassesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SeasonPassResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAdminSeasonPassesId().'
            );
        }

        if (requestParameters['updateSeasonPassBody'] == null) {
            throw new runtime.RequiredError(
                'updateSeasonPassBody',
                'Required parameter "updateSeasonPassBody" was null or undefined when calling updateAdminSeasonPassesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/season-passes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSeasonPassBodyToJSON(requestParameters['updateSeasonPassBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SeasonPassResponseFromJSON(jsonValue));
    }

    /**
     * Update a season pass
     */
    async updateAdminSeasonPassesId(requestParameters: UpdateAdminSeasonPassesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SeasonPassResponse> {
        const response = await this.updateAdminSeasonPassesIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
